import { combineReducers } from 'redux';
import { reducer as formReducer } from 'redux-form';
import accountReducer from './accountReducer';
import notificationsReducer from './notificationsReducer';
import txnReducer from './txnReducer';
import raisedIssueReducer from './raisedIssueReducer';

const rootReducer = combineReducers({
  account: accountReducer,
  notifications: notificationsReducer,
  form: formReducer,
  txn: txnReducer,
  raisedIssueState: raisedIssueReducer
});

export default rootReducer;
